import React from 'react';

interface FormProps {
  children: React.ReactNode;
  classes?: string;
}

const Form = ({ children, classes = '' }: FormProps) => {
  return <div className={`form ${classes}`}>{children}</div>;
};

export default Form;
